import { Button } from '@/components'
import { appSelectors, useAppStore } from '@/store'
import { DownloadFormat } from '@/store/app.types'
import { DownloadIcon } from '@radix-ui/react-icons'

export const Download: React.FC<{ id: string }> = ({ id }) => {
  const { download } = useAppStore(appSelectors.asyncActions)
  const btnClass =
    'flex justify-center gap-3 px-12 py-6 flex-1 rounded-xl bg-glow/10 text-white/80 cursor-pointer'
  const iconClass = 'w-5 h-5 text-white/30'

  return (
    <div className="flex gap-3 justify-between py-6 max-md:overflow-x-auto max-md:px-3">
      <Button
        className={btnClass}
        variant="ghost"
        onClick={() => download(id, DownloadFormat.CSV)}
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.CSV}
      </Button>
      <Button
        className={btnClass}
        onClick={() => download(id, DownloadFormat.HTML)}
        variant="ghost"
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.HTML}
      </Button>
      <Button
        className={btnClass}
        variant="ghost"
        onClick={() => download(id, DownloadFormat.JSON)}
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.JSON}
      </Button>
      <Button
        className={btnClass}
        variant="ghost"
        onClick={() => download(id, DownloadFormat.TXT)}
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.TXT}
      </Button>
      <Button
        className={btnClass}
        variant="ghost"
        onClick={() => download(id, DownloadFormat.XLSX)}
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.XLSX}
      </Button>
      <Button
        className={btnClass}
        variant="ghost"
        onClick={() => download(id, DownloadFormat.XML)}
      >
        <DownloadIcon className={iconClass} /> {DownloadFormat.XML}
      </Button>
    </div>
  )
}
